/* eslint-disable react/no-unknown-property */
import React from 'react';
import {
  HStack, ICON_ACCOUNT_OUTLINE, ICON_PHONE_OFF_OUTLINE, Icon, SimpleTable, Stack, Text,
} from '@doveit/bricks';
import { capitalizeWords } from '@doveit/hammer';
import { MissedCalls } from '../../../providers/api/dtos/applicant';
import { MAX_NO_ASWER_RETRY } from '../../containers/no-answer-action/NoAnswerAction';
import { jobApplicationHrUsers } from '../../constants';
import DateViewer from '../../../components/date-viewer/DateViewer';

export interface ApplicantMissedCallRegistryListProps {
  missedCalls: MissedCalls,
  maxAttempts?: number,
}

function getAuthorDisplayName(email: string): string {
  const user = jobApplicationHrUsers.find((u) => u.email === email);
  if (!user) return email;
  const [firstName, ...rest] = user.name.split(' ');
  return `${firstName[0].toUpperCase()}. ${capitalizeWords(rest.join(' '))}`;
}

const ApplicantMissedCallRegistryList: React.FC<ApplicantMissedCallRegistryListProps> = ({
  missedCalls,
  maxAttempts = MAX_NO_ASWER_RETRY,
}) => {
  const remaining = maxAttempts - missedCalls.counter;
  const { list, counter } = missedCalls;

  return (
    <Stack gap={200}>
      <Text.BodySmall align="left">
        <strong>{remaining}</strong> chiamate senza risposta prima dell&apos;archiviazione
      </Text.BodySmall>
      <SimpleTable aria-label="Lista chiamate senza risposta">
        <SimpleTable.Body>
          {list.map((call, index) => (
            <SimpleTable.Row
              // eslint-disable-next-line react/no-array-index-key
              key={`missed-call-${index}`}
              aria-label="Chiamata senza risposta"
              lowlighted={counter - index <= 0}
            >
              <SimpleTable.Cell>
                <HStack gap={100} wrap="nowrap">
                  <Icon path={ICON_PHONE_OFF_OUTLINE} />
                  <DateViewer
                    stringDate={call.date}
                    checkIfToday
                    withStrong
                    withHour
                  />
                </HStack>
              </SimpleTable.Cell>
              <SimpleTable.Cell>
                <HStack gap={50} wrap="nowrap">
                  <Icon path={ICON_ACCOUNT_OUTLINE} />
                  <Text.BodySmall>{getAuthorDisplayName(call.createdBy)}</Text.BodySmall>
                </HStack>
              </SimpleTable.Cell>
            </SimpleTable.Row>
          ))}
        </SimpleTable.Body>
      </SimpleTable>
    </Stack>
  );
};

export default ApplicantMissedCallRegistryList;
